import { createAction } from "redux-starter-kit";
import {
  UPLOAD_ITEM_SET_LOADED_ID,
  UPLOAD_ITEM_LOADED_ERR,
  UPLOAD_ITEM_SET_DATA,
  UPLOAD_ITEM_APPEND_DATA,
  MODIFY_UPLOAD_ITEM,
  REMOVE_MEDIA_ITEM
} from "../actionTypes";

import {
  getMediasApi,
  getUploadCredentialApi,
  uploadMediaFileApi,
  addMediaToServerApi
} from "../../api/issues";

import { generateUniqueID } from "../../utils/utils";

export const setUploadItemLoadedIDAction = createAction(
  UPLOAD_ITEM_SET_LOADED_ID
);
export const setUploadItemLoadErrorAction = createAction(
  UPLOAD_ITEM_LOADED_ERR
);
export const setUploadItemSetDataAction = createAction(UPLOAD_ITEM_SET_DATA);
export const setUploadItemAppendDataAction = createAction(
  UPLOAD_ITEM_APPEND_DATA
);
export const modifyUploadItemAction = createAction(MODIFY_UPLOAD_ITEM);
export const removeMediaItemAction = createAction(REMOVE_MEDIA_ITEM);

export function uploadMediaItemRequestAction(
  id,
  file,
  issueID,
  isPdf,
  title,
  mediaType
) {
  return async dispatch => {
    dispatch(modifyUploadItemAction({ id: id, progress: 0 }));

    try {
      const credential = await getUploadCredentialApi(file.name);
      await uploadMediaFileApi(file, credential, progress =>
        dispatch(modifyUploadItemAction({ id: id, progress: progress }))
      );
      const serverData = await addMediaToServerApi(
        issueID,
        isPdf,
        title,
        credential.key,
        mediaType
      );

      dispatch(modifyUploadItemAction({ id, serverData }));
    } catch (e) {
      dispatch(modifyUploadItemAction({ id: id, progress: -1 }));
    }
  };
}

export function loadUploadItemRequestAction(issueID, isPdf) {
  return async dispatch => {
    dispatch(
      setUploadItemLoadedIDAction({ loadedIssueID: null, loadedIsPdf: null })
    );
    dispatch(setUploadItemSetDataAction({ mediaIDs: [], mediaDicts: {} }));
    dispatch(setUploadItemLoadErrorAction({ errMsg: null }));

    try {
      const [videos, audios] = await Promise.all([
        getMediasApi(issueID, isPdf, true),
        getMediasApi(issueID, isPdf, false)
      ]).catch(e => {
        throw e;
      });

      let i;
      for (i = 0; i < videos.length; i++) {
        const id = generateUniqueID();
        const video = videos[i];

        const dict = {
          mediaType: "video",
          serverData: video
        };

        dispatch(setUploadItemAppendDataAction({ id: id, media: dict }));
      }

      for (i = 0; i < audios.length; i++) {
        const id = generateUniqueID();
        const audio = audios[i];

        const dict = {
          mediaType: "audio",
          serverData: audio
        };

        dispatch(setUploadItemAppendDataAction({ id: id, media: dict }));
      }
    } catch (e) {
      dispatch(setUploadItemLoadErrorAction({ errMsg: e.toString() }));
    }

    dispatch(
      setUploadItemLoadedIDAction({
        loadedIssueID: issueID,
        loadedIsPdf: isPdf
      })
    );
  };
}
